// export { default } from './DownloadModal';
import DownloadModal from './DownloadModal';

export default DownloadModal;

